module.exports = __webpack_public_path__ + "img/0c18a7870bb0d17f0664dbb25c6e3c2.a5fd863b.png";